<template>
<b-container
  class="d-flex section p-0 px-sm-3"
  fluid
  >
  <b-row class="m-auto text-center justify-content-center">
    <b-col class="p-0">
      
      <b-container
				class="text-center p-xl-5"
				fluid
			>
				<b-row class="m-auto text-center justify-content-center">
					<b-col
						cols="12"
						xl="8">
						<div class="m-5">
							<b-img :src="require('../assets/trinapp-aconex.png')" style="width: 130px;" />
						</div>
						<div class="headline-wrapper">
							<h1>Fast Upload of Your</h1>
							<h1>Drawings &amp; Specs with </h1>
							<h1 class="red">Oracle aconex Link</h1>
						</div>
						<div class="mx-auto">
							<b-container class="px-0 py-5 text-center">
					<b-row>
						<b-col>
							<p class="font-weight-bold">Automated extraction and publishing into Oracle aconex of Sheet Number, Sheet Title and Discipline, saving you considerable time.</p>
							
							<p>Capable of processing thousands of sheets in one go.</p>
							
							<p>Our learning focus optimized OCR (Patent Pending) system enables high quality data capture from raster PDFs and images</p>
							
							<p>Trinity will also create clickable page links for easy navigation between documents.</p>

						</b-col>
					</b-row>
							</b-container>
						</div>
						<b-img :src="require('../assets/oracle-gold.png')" class="oracle-gold-img" fluid />
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<div class="text-center mb-5">
							<slot name="buttons">
					<b-button
						size="lg"
						class="btn-orange mt-5 mx-3"
						href="https://trinpod.us/pricing?industry=construction"
						>
						Get Started
					</b-button>
							</slot>
						</div>
					</b-col>
				</b-row>
      </b-container>
      
    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
    name: "Layout10",
    methods: {
	scrollToTop: function () {
	    window.scrollTo(0,0);
        }
    }
}
</script>

<style scoped>
@media (max-width: 575px) {
	.headline-wrapper > h1 {
		font-size: 2rem !important;
	}
	.oracle-gold-img {
		max-width: 80%;
	}
}
</style>
